export const MONTH_HOURS = [
	{
		label: 'Full time (160 hours)',
		value: 160,
	},
	{
		label: 'Part time (120 hours)',
		value: 120,
	},
	{
		label: 'Part time (80 hours)',
		value: 80,
	},
];
